// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1r2Lh","author":"Table_author__QCbpB","authorImage":"Table_authorImage__v1sFT","unreadRow":"Table_unreadRow__2ztkR"};